import { useState, useEffect } from "react";

const useIsMounted = () => {
  const [isMounted, setIsMounted] = useState<boolean>(false);

  useEffect(() => {
    // Set to true when component is mounted
    setIsMounted(true);

    // Cleanup function: set to false when component is unmounted
    return () => {
      setIsMounted(false);
    };
  }, []); // Empty dependency array to run only on mount/unmount

  return { isMounted };
};

export default useIsMounted;
